// import firebase from '@/services/firebase'
import { serverTimestamp, getDatabase } from '@firebase/database';

export const realtimeDB = getDatabase();
export const ts = serverTimestamp();
